import Vue from "vue";
import VueI18n from "vue-i18n";
import { enTranslation } from "./locales/en/translation.js";
import { zhTranslation } from "./locales/zh/translation.js";
import { ruTranslation } from "./locales/ru/translation.js";
import { deTranslation } from "./locales/de/translation.js";
import { frTranslation } from "./locales/fr/translation.js";
import { esTranslation } from "./locales/es/translation.js";
import { itTranslation } from "./locales/it/translation.js";

Vue.use(VueI18n);

const messages = {
  en: enTranslation,
  zh: zhTranslation,
  ru: ruTranslation,
  de: deTranslation,
  fr: frTranslation,
  es: esTranslation,
  it: itTranslation,
};

const getBrowserLocale = () => {
  const navigatorLocale = navigator.language || navigator.userLanguage;
  if (navigatorLocale) {
    const langCode = navigatorLocale.split("-")[0];
    if (Object.keys(messages).includes(langCode)) {
      return langCode;
    }
  }
  return "en";
};
localStorage.setItem("language", 'en');
export default new VueI18n({
  locale: localStorage.getItem("language") || getBrowserLocale(),
  fallbackLocale: "en",
  messages,
});
